import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "fb-icon",
  "use": "fb-icon-usage",
  "viewBox": "0 0 59 59",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 59 59\" id=\"fb-icon\"><g fill=\"none\" fill-rule=\"evenodd\"><ellipse fill=\"#003595\" cx=\"29.33\" cy=\"29.198\" rx=\"29.33\" ry=\"29.198\" /><path d=\"M34.596 29.282h-3.474v13.353h-5.264V29.282h-2.504v-4.693h2.504v-3.037c0-2.172.983-5.573 5.31-5.573l3.9.017v4.556H32.24c-.464 0-1.117.243-1.117 1.279v2.762h3.934l-.46 4.689z\" fill=\"#FFF\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol